__turbopack_context__.v({
  "Large": "t7I7EW_Large",
  "clamp": "t7I7EW_clamp" + " " + __turbopack_context__.i(7213)["lineClamp"],
  "hoverIFrame": "t7I7EW_hoverIFrame",
  "hoverIFrameWrapper": "t7I7EW_hoverIFrameWrapper",
  "newTabIcon": "t7I7EW_newTabIcon",
  "pressDown": "t7I7EW_pressDown",
  "release": "t7I7EW_release",
  "root": "t7I7EW_root",
});
